import { render, staticRenderFns } from "./IframeVideo.vue?vue&type=template&id=051405a9&"
import script from "./IframeVideo.vue?vue&type=script&lang=js&"
export * from "./IframeVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports